import { render, staticRenderFns } from "./Failed-Delivery.vue?vue&type=template&id=7a38cc04"
import script from "./Failed-Delivery.vue?vue&type=script&lang=js"
export * from "./Failed-Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports